import React from 'react';

const VARIANTS = ['default', 'primary', 'success', 'info', 'warning', 'danger'];

/**
 * Replacement for react-bootstrap's <Label> (Bootstrap 3 label pill).
 *
 * @param {object} props
 * @param {'default'|'primary'|'success'|'info'|'warning'|'danger'} [props.variant='default']
 *   Unknown values fall back to default.
 */
const Chip = ({ variant = 'default', className, children, ...rest }) => {
  const classes = [
    'ui-chip',
    `ui-chip--${VARIANTS.includes(variant) ? variant : 'default'}`,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <span className={classes} {...rest}>
      {children}
    </span>
  );
};

export default Chip;
